import { createContext, ReactNode, useContext } from "react";
import { Link } from "react-router-dom";

/**
 * Plano de 07/10/2026 (Frente 1, item 4): o layout Private calcula o acesso aos recursos
 * Aplicabilidades e Tabelas de Preços (mesma regra do menu) e o expõe aqui para a guarda de rota.
 * A guarda é necessária porque a API do legado de Tabelas de Preços continua aceitando a tela
 * Exportacao — sem ela, quem não tem o recurso abriria /tabelas-precos pela URL.
 */
export interface IAcessoRecursos {
  aplicabilidades: boolean;
  tabelasPreco: boolean;
  /** false enquanto o layout ainda busca empresa/usuário. */
  carregado: boolean;
}

export const AcessoRecursosContext = createContext<IAcessoRecursos>({
  aplicabilidades: false,
  tabelasPreco: false,
  carregado: false,
});

export const useAcessoRecursos = () => useContext(AcessoRecursosContext);

interface ExigeRecursoProps {
  recurso: "aplicabilidades" | "tabelasPreco";
  children: ReactNode;
}

export const ExigeRecurso = ({ recurso, children }: ExigeRecursoProps) => {
  const acesso = useAcessoRecursos();

  if (!acesso.carregado) {
    return (
      <div style={{ padding: 32, textAlign: "center", color: "#555" }}>Carregando...</div>
    );
  }

  if (!acesso[recurso]) {
    return (
      <div style={{ padding: 32, textAlign: "center", color: "#555" }}>
        <p>Recurso não liberado para este usuário.</p>
        <Link to="/">Voltar para o início</Link>
      </div>
    );
  }

  return <>{children}</>;
};
